// extracted by mini-css-extract-plugin
export var active = "_bs-7";
export var container = "_bs-0";
export var evenWidth = "_bs-4";
export var large = "_bs-5";
export var outlet = "_bs-8";
export var slide = "_bs-2";
export var small = "_bs-6";
export var tab = "_bs-3";
export var tabs = "_bs-1";